import {
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
export default function CardEle({ item, callback, cbt }) {
  return (
    <Card
      onClick={() => {
        callback(item);
      }}
      sx={{
        cursor: "pointer",
        backgroundColor: "#E9E9FF",
        padding: "10px",
      }}
    >
      <CardContent sx={{ padding: "0rem 0.7rem !important" }}>
        <Grid container>
          <Grid item xs={12} paddingY={1}>
            <Typography
              // color="primary"
              sx={{
                textAlign: "left",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                overflow: "Hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 500,
                color: "primary.main",
              }}
            >
              {item?.message}
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ display: "flex", justifyContent: "end" }}>
            <Button
              variant="contained"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              onClick={(e) => {
                e.stopPropagation();
                cbt(item);
              }}
            >
              Click Here To Send!
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
